import i18next from 'i18next'
import React from 'react'
import {
    DatePicker,
    TimePicker,
    DateTimePicker,
    MuiPickersUtilsProvider,
} from '@material-ui/pickers'
export const getPageTitle = path => {
    let pageTitle = i18next.t('registry_title') ? `${i18next.t('registry_title')}-` : ''
    switch (path) {
        case '/':
            pageTitle += `${i18next.t('appPageTitle.signup')}`
            break
        case '/resetpassword':
            pageTitle += `${i18next.t('appPageTitle.resetPassword')}`
            break
        case '/signup':
            pageTitle += `${i18next.t('appPageTitle.signup')}`
            break
        case '/forgotpassword':
            pageTitle += `${i18next.t('appPageTitle.forgotPassword')}`
            break
        case '/login':
            pageTitle += `${i18next.t('appPageTitle.login')}`
            break
        case '/login-my-account':
            pageTitle += `${i18next.t('appPageTitle.login')}`
            break
        case '/processcompleted':
            pageTitle += `${i18next.t('appPageTitle.processcompleted')}`
            break
        case '/welcome':
            pageTitle += `${i18next.t('appPageTitle.welcome')}`
            break
        case '/onboard':
            pageTitle += `${i18next.t('appPageTitle.onboarding')}`
            break
        case '/dashboard':
            pageTitle += `${i18next.t('appPageTitle.dashboard')}`
            break
        default:
            break
    }
    return pageTitle
}

export const uid12 = () => {
    return uid4() + uid4() + uid4()
}

export const uid4 = () => {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1)
}

export const customFilterOption = (option, rawInput) => {
    const words = rawInput ? rawInput.split(' ') : []
    return words.reduce(
        (acc, cur) => acc && option.label.toLowerCase().includes(cur.toLowerCase()),
        true
    )
}

export const redirectToProgramSignUp = async (
    url,
    componentType,
    cliententityid,
    parentcliententityid
) => {
    let key = ''
    if (url && cliententityid) key = `${url}&client-entity-id=${cliententityid}`

    if (key) {
        if (componentType) key = `${key}&open-on-section=${componentType}`

        if (parentcliententityid)
            key = `${key}&parent-client-entity-id=${parentcliententityid}`

        validateURL(key)
    }
}

export const redirectToProgramRegistration = (registrationurl, parentcliententityid) => {
    let key = ''
    if (registrationurl) key = registrationurl

    if (key) {
        if (parentcliententityid)
            key = `${key}&parent-client-entity-id=${parentcliententityid}`

        validateURL(key)
    }
}

export const redirectToProgramDashboard = url => {
    if (url) validateURL(url)
}

export const validateURL = URL => {
    if (URL && typeof URL === 'string') {
        const redirector =
            URL.indexOf('http://') === 0 || URL.indexOf('https://') === 0
                ? URL
                : `https://${URL}`

        return window.open(redirector, '_blank')
    }
}

export const prependZero = n => {
    if (n !== 0 && n < 9) return '0' + n
    else return n
}

export const formatSelectedOption = (selectedOptions, endpoint) => {
    let returnValue = ''
    if (!selectedOptions) return returnValue
    if (Object.keys(selectedOptions).length === 0) return returnValue
    switch (endpoint) {
        case 'clientprogram/masterdata/type/28':
            returnValue = {
                value: selectedOptions.hospitalownershipid
                    ? selectedOptions.hospitalownershipid
                    : '',
                label: selectedOptions.hospitalownershipname
                    ? selectedOptions.hospitalownershipname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/45':
            returnValue = {
                value: selectedOptions['raceid'] ? selectedOptions['raceid'] : '',
                label: selectedOptions['racename'] ? selectedOptions['racename'] : '',
            }
            break
        case 'clientprogram/masterdata/type/46':
            returnValue = {
                value: selectedOptions['ethnicityid']
                    ? selectedOptions['ethnicityid']
                    : '',
                label: selectedOptions['ethnicityname']
                    ? selectedOptions['ethnicityname']
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/47':
            returnValue = {
                value: selectedOptions['entrylevelptdegreeid']
                    ? selectedOptions['entrylevelptdegreeid']
                    : '',
                label: selectedOptions['entrylevelptdegreename']
                    ? selectedOptions['entrylevelptdegreename']
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/48':
            returnValue = {
                value: selectedOptions['highestacademicdegreeid']
                    ? selectedOptions['highestacademicdegreeid']
                    : '',
                label: selectedOptions['highestacademicdegreename']
                    ? selectedOptions['highestacademicdegreename']
                    : '',
            }
            break
        case 'clientprogram/state':
            returnValue = {
                value: selectedOptions['graduationstateid']
                    ? selectedOptions['graduationstateid']
                    : '',
                label: selectedOptions['graduationstatename']
                    ? selectedOptions['graduationstatename']
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/49':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.aptaresidencyfellowshipid,
                    label: option.aptaresidencyfellowshipname,
                    obj: {...option},
                })
            })
            break
        case 'clientprogram/masterdata/type/50':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.abptsspecializationid,
                    label: option.abptsspecializationname,
                    obj: {...option},
                })
            })
            break
        case 'clientprogram/masterdata/type/29':
            returnValue = {
                value: selectedOptions['entitytypedepartmentid']
                    ? selectedOptions['entitytypedepartmentid']
                    : '',
                label: selectedOptions['entitytypedepartmentname']
                    ? selectedOptions['entitytypedepartmentname']
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/4':
            returnValue = {
                value: selectedOptions.cliententitysettingid
                    ? selectedOptions.cliententitysettingid
                    : '',
                label: selectedOptions.cliententitysettingname
                    ? selectedOptions.cliententitysettingname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/3':
            returnValue = {
                value: selectedOptions.cliententitytypeid
                    ? selectedOptions.cliententitytypeid
                    : '',
                label: selectedOptions.cliententitytypename
                    ? selectedOptions.cliententitytypename
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/55':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.cliententityspecialityid,
                    label: option.cliententityspecialityname,
                    obj: {...option},
                })
            })
            break    
        case 'clientprogram/masterdata/type/25':
            returnValue = {
                value: selectedOptions.contacttypeid ? selectedOptions.contacttypeid : '',
                label: selectedOptions.contacttypename
                    ? selectedOptions.contacttypename
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/11':
            returnValue = {
                value: selectedOptions.cliniciantypeid
                    ? selectedOptions.cliniciantypeid
                    : '',
                label: selectedOptions.cliniciantypename
                    ? selectedOptions.cliniciantypename
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/31':
            returnValue = {
                value: selectedOptions.professionid ? selectedOptions.professionid : '',
                label: selectedOptions.professionname
                    ? selectedOptions.professionname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/32':
            returnValue = {
                value: selectedOptions.careforurologicpatientsid
                    ? selectedOptions.careforurologicpatientsid
                    : '',
                label: selectedOptions.careforurologicpatientsname
                    ? selectedOptions.careforurologicpatientsname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/41':
            returnValue = {
                value: selectedOptions.noncliniciantypeid
                    ? selectedOptions.noncliniciantypeid
                    : '',
                label: selectedOptions.noncliniciantypename
                    ? selectedOptions.noncliniciantypename
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/18/0':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.contactroleid,
                    label: option.contactrolename,
                    obj: {...option},
                })
            })
            break
        case 'clientprogram/masterdata/type/18/1':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.contactroleid,
                    label: option.contactrolename,
                    obj: {...option},
                })
            })
            break
        case 'clientprogram/masterdata/type/18':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.contactroleid,
                    label: option.contactrolename,
                    obj: {...option},
                })
            })
            break
        case 'clientprogram/masterdata/type/22':
            returnValue = {
                value: selectedOptions.designationid ? selectedOptions.designationid : '',
                label: selectedOptions.designationname
                    ? selectedOptions.designationname
                    : '',
            }
            break
        case 'clientprogram/speciality':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.specialityid,
                    label: option.specialityname,
                    obj: {...option},
                })
            })
            break

        case 'cliententity/contact':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.cliententitycontactid,
                    label: option.contactname,
                    obj: {...option},
                })
            })
            break

        case 'clientprogram/systeminformation/1':
            returnValue = {
                value: selectedOptions.ehrsystemid ? selectedOptions.ehrsystemid : '',
                label: selectedOptions.ehrsystemname ? selectedOptions.ehrsystemname : '',
            }

            break

        case 'clientprogram/systeminformation/2':
            returnValue = {
                value: selectedOptions.lissystemid ? selectedOptions.lissystemid : '',
                label: selectedOptions.lissystemname ? selectedOptions.lissystemname : '',
            }

            break

        case 'clientprogram/systeminformation/3':
            returnValue = {
                value: selectedOptions.pmsystemid ? selectedOptions.pmsystemid : '',
                label: selectedOptions.pmsystemname ? selectedOptions.pmsystemname : '',
            }
            break

        case 'clientprogram/systeminformation/4':
            returnValue = {
                value: selectedOptions.rcmsystemid ? selectedOptions.rcmsystemid : '',
                label: selectedOptions.rcmsystemname ? selectedOptions.rcmsystemname : '',
            }
            break

        case 'clientprogram/masterdata/type/12':
            returnValue = {
                value: selectedOptions.areatypeid ? selectedOptions.areatypeid : '',
                label: selectedOptions.areatypename ? selectedOptions.areatypename : '',
            }
            break

        case 'clientprogram/masterdata/type/13':
            returnValue = {
                value: selectedOptions.ehrhostid ? selectedOptions.ehrhostid : '',
                label: selectedOptions.ehrhostname ? selectedOptions.ehrhostname : '',
            }
            break

        case 'clientprogram/masterdata/type/21':
            returnValue = {
                value: selectedOptions.ehrstageid ? selectedOptions.ehrstageid : '',
                label: selectedOptions.ehrstagename ? selectedOptions.ehrstagename : '',
            }
            break
        case 'clientprogram/masterdata/type/23':
            returnValue = {
                value: selectedOptions.entitytypeid ? selectedOptions.entitytypeid : '',
                label: selectedOptions.entitytypename
                    ? selectedOptions.entitytypename
                    : '',
            }
            break
        case 'agreement/contact/role/0':
            returnValue = {
                value: selectedOptions.cliententitycontactid
                    ? selectedOptions.cliententitycontactid
                    : '',
                label: selectedOptions.emailaddress ? selectedOptions.emailaddress : '',
            }
            break
        case 'clientprogram/paymentuserdetails':
            returnValue = {
                value: selectedOptions.emailaddress ? selectedOptions.emailaddress : '',
                label: selectedOptions.emailaddress ? selectedOptions.emailaddress : '',
            }
            break
        case 'agreement/contact/role/2':
            returnValue = {
                value: selectedOptions.cliententitycontactid
                    ? selectedOptions.cliententitycontactid
                    : '',
                label: selectedOptions.emailaddress ? selectedOptions.emailaddress : '',
            }
            break
        case 'agreement/type':
            returnValue = {
                value: selectedOptions.agreementid ? selectedOptions.agreementid : '',
                label: selectedOptions.agreementname ? selectedOptions.agreementname : '',
            }
            break

        case 'cliententity/tin':
            returnValue = {
                value: selectedOptions.cliententitytininformationid
                    ? selectedOptions.cliententitytininformationid
                    : '',
                label: selectedOptions.tin ? selectedOptions.tin : '',
            }
            break

        case 'myaccount/cliententity/tin':
            returnValue = {
                value: selectedOptions.cliententitytininformationid
                    ? selectedOptions.cliententitytininformationid
                    : '',
                label: selectedOptions.tin ? selectedOptions.tin : '',
            }
            break

        case 'clientprogram/masterdata/type/26':
            returnValue = {
                value: selectedOptions.rdbmsid ? selectedOptions.rdbmsid : '',
                label: selectedOptions.rdbmsname ? selectedOptions.rdbmsname : '',
            }
            break
        case 'clientprogram/masterdata/type/34':
            returnValue = {
                value: selectedOptions.ehrfileformatid
                    ? selectedOptions.ehrfileformatid
                    : '',
                label: selectedOptions.ehrfileformatname
                    ? selectedOptions.ehrfileformatname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/35':
            returnValue = {
                value: selectedOptions.pmfileformatid
                    ? selectedOptions.pmfileformatid
                    : '',
                label: selectedOptions.pmfileformatname
                    ? selectedOptions.pmfileformatname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/54':
            returnValue = {
                value: selectedOptions.rcmfileformatid
                    ? selectedOptions.rcmfileformatid
                    : '',
                label: selectedOptions.rcmfileformatname
                    ? selectedOptions.rcmfileformatname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/36':
            returnValue = {
                value: selectedOptions.lisfileformatid
                    ? selectedOptions.lisfileformatid
                    : '',
                label: selectedOptions.lisfileformatname
                    ? selectedOptions.lisfileformatname
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/42':
            returnValue = {
                value: selectedOptions.vartypeid ? selectedOptions.vartypeid : '',
                label: selectedOptions.vartypename ? selectedOptions.vartypename : '',
            }
            break
        case 'clientprogram/masterdata/type/1':
            returnValue = {
                value: selectedOptions.gendertypeid ? selectedOptions.gendertypeid : '',
                label: selectedOptions.gendertypename
                    ? selectedOptions.gendertypename
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/33':
            returnValue = {
                value: selectedOptions.titleid ? selectedOptions.titleid : '',
                label: selectedOptions.titlename ? selectedOptions.titlename : '',
            }
            break

        //Technical survey MyAccount
        case 'myaccount/cliententity/contact':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.cliententitycontactid,
                    label: option.contactname,
                    obj: {...option},
                })
            })
            break
        case 'myaccount/technicalsurvey/systeminformation/1':
            returnValue = {
                value: selectedOptions.ehrsystemid ? selectedOptions.ehrsystemid : '',
                label: selectedOptions.ehrsystemname ? selectedOptions.ehrsystemname : '',
            }
            break
        case 'myaccount/technicalsurvey/systeminformation/2':
            returnValue = {
                value: selectedOptions.lissystemid ? selectedOptions.lissystemid : '',
                label: selectedOptions.lissystemname ? selectedOptions.lissystemname : '',
            }

            break
        case 'myaccount/technicalsurvey/systeminformation/3':
            returnValue = {
                value: selectedOptions.pmsystemid ? selectedOptions.pmsystemid : '',
                label: selectedOptions.pmsystemname ? selectedOptions.pmsystemname : '',
            }
            break
        case 'myaccount/technicalsurvey/systeminformation/4':
            returnValue = {
                value: selectedOptions.rcmsystemid ? selectedOptions.rcmsystemid : '',
                label: selectedOptions.rcmsystemname ? selectedOptions.rcmsystemname : '',
            }
            break
        case 'myaccount/cliententity/masterdata/type/13':
            returnValue = {
                value: selectedOptions.ehrhostid ? selectedOptions.ehrhostid : '',
                label: selectedOptions.ehrhostname ? selectedOptions.ehrhostname : '',
            }
            break
        case 'myaccount/cliententity/masterdata/type/21':
            returnValue = {
                value: selectedOptions.ehrstageid ? selectedOptions.ehrstageid : '',
                label: selectedOptions.ehrstagename ? selectedOptions.ehrstagename : '',
            }
            break
        case 'myaccount/cliententity/masterdata/type/26':
            returnValue = {
                value: selectedOptions.rdbmsid ? selectedOptions.rdbmsid : '',
                label: selectedOptions.rdbmsname ? selectedOptions.rdbmsname : '',
            }
            break
        case 'myaccount/cliententity/masterdata/type/34':
            returnValue = {
                value: selectedOptions.ehrfileformatid
                    ? selectedOptions.ehrfileformatid
                    : '',
                label: selectedOptions.ehrfileformatname
                    ? selectedOptions.ehrfileformatname
                    : '',
            }
            break
        case 'myaccount/cliententity/masterdata/type/35':
            returnValue = {
                value: selectedOptions.pmfileformatid
                    ? selectedOptions.pmfileformatid
                    : '',
                label: selectedOptions.pmfileformatname
                    ? selectedOptions.pmfileformatname
                    : '',
            }
            break
        case 'myaccount/cliententity/masterdata/type/36':
            returnValue = {
                value: selectedOptions.lisfileformatid
                    ? selectedOptions.lisfileformatid
                    : '',
                label: selectedOptions.lisfileformatname
                    ? selectedOptions.lisfileformatname
                    : '',
            }
            break
        case 'user/program/cliententity':
            returnValue = {
                value: selectedOptions.cliententityid
                    ? selectedOptions.cliententityid
                    : '',
                label: selectedOptions.name ? selectedOptions.name : '',
                obj: {...selectedOptions},
            }
            break
        case 'user/program':
            returnValue = {
                value: selectedOptions.clientprogramid
                    ? selectedOptions.clientprogramid
                    : '',
                label: selectedOptions.name ? selectedOptions.name : '',
                obj: {...selectedOptions},
            }
            break
        case 'clientprogram/roles':
            if (
                selectedOptions &&
                Array.isArray(selectedOptions) &&
                selectedOptions.length > 0
            ) {
                returnValue = []
                selectedOptions.forEach(option => {
                    returnValue.push({
                        value: option.clientprogramrolemappingid,
                        label: option.name,
                        obj: {...option},
                    })
                })
            } else {
                returnValue = {
                    value: selectedOptions.clientprogramrolemappingid
                        ? selectedOptions.clientprogramrolemappingid
                        : '',
                    label: selectedOptions.name ? selectedOptions.name : '',
                    obj: {...selectedOptions},
                }
            }
            break
        case 'clientprogram/authenticationtype':
            returnValue = {
                value: selectedOptions.authenticationtypeid
                    ? selectedOptions.authenticationtypeid
                    : '',
                label: selectedOptions.name ? selectedOptions.name : '',
                obj: {...selectedOptions},
            }
            break
        case 'myaccount/cliententity/masterdata/type/18':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.contactroleid,
                    label: option.contactrolename,
                    obj: {...option},
                })
            })
            break
        case 'clientprogram/masterdata/type/43':
            returnValue = {
                value: selectedOptions.isaptamemberid
                    ? selectedOptions.isaptamemberid
                    : '',
                label: selectedOptions.isaptamembername
                    ? selectedOptions.isaptamembername
                    : '',
            }
            break
        case 'clientprogram/masterdata/type/51':
            returnValue = []
            selectedOptions.forEach(option => {
                returnValue.push({
                    value: option.memberpopulationid,
                    label: option.memberpopulationname,
                    obj: {...option},
                })
            })
            break
        default:
            break
    }
    return returnValue
}

export const formatDropDownDataSource = (dataList, endPoint) => {
    let dropDownData = []
    switch (endPoint) {
        case 'clientprogram/masterdata/type/28':
            const hospitaalOwnerShipOptionList = dataList.hospitalownership
                ? dataList.hospitalownership
                : []
            hospitaalOwnerShipOptionList.forEach(element => {
                dropDownData.push({
                    value: element.hospitalownershipid,
                    label: element.hospitalownershipname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/29':
            const cliententitydeptOptionList = dataList['entitytypedepartment']
                ? dataList['entitytypedepartment']
                : []
            cliententitydeptOptionList.forEach(element => {
                dropDownData.push({
                    value: element['entitytypedepartmentid'],
                    label: element['entitytypedepartmentname'],
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/45':
            const raceOptionList = dataList['race'] ? dataList['race'] : []
            raceOptionList.forEach(element => {
                dropDownData.push({
                    value: element['raceid'],
                    label: element['racename'],
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/46':
            const ethnicityOptionList = dataList['ethnicity'] ? dataList['ethnicity'] : []
            ethnicityOptionList.forEach(element => {
                dropDownData.push({
                    value: element['ethnicityid'],
                    label: element['ethnicityname'],
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/47':
            const entrylevelptdegreeList = dataList['entrylevelptdegree']
                ? dataList['entrylevelptdegree']
                : []
            entrylevelptdegreeList.forEach(element => {
                dropDownData.push({
                    value: element['entrylevelptdegreeid'],
                    label: element['entrylevelptdegreename'],
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/48':
            const highestacademicdegreeList = dataList['highestacademicdegree']
                ? dataList['highestacademicdegree']
                : []
            highestacademicdegreeList.forEach(element => {
                dropDownData.push({
                    value: element['highestacademicdegreeid'],
                    label: element['highestacademicdegreename'],
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/state':
            const graduationstateList = dataList['graduationstate']
                ? dataList['graduationstate']
                : []
            graduationstateList.forEach(element => {
                dropDownData.push({
                    value: element['graduationstateid'],
                    label: element['graduationstatename'],
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/50':
            const arr2 = getUniqueObjectArray(
                dataList.abptsspecialization,
                'abptsspecializationid'
            )
            // const arr = dataList.speciality
            arr2.forEach(element => {
                dropDownData.push({
                    value: element.abptsspecializationid,
                    label: element.abptsspecializationname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/49':
            const arr1 = getUniqueObjectArray(
                dataList.aptaresidencyfellowship,
                'aptaresidencyfellowshipid'
            )
            // const arr = dataList.speciality
            arr1.forEach(element => {
                dropDownData.push({
                    value: element.aptaresidencyfellowshipid,
                    label: element.aptaresidencyfellowshipname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/3':
            const cliententitytypeOptionList = dataList.cliententitytype
                ? dataList.cliententitytype
                : []
            cliententitytypeOptionList.forEach(element => {
                dropDownData.push({
                    value: element.cliententitytypeid,
                    label: element.cliententitytypename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/55':
            const cliententityspecialityOptionList = dataList.cliententityspeciality
                ? dataList.cliententityspeciality
                : []
            cliententityspecialityOptionList.forEach(element => {
                dropDownData.push({
                    value: element.cliententityspecialityid,
                    label: element.cliententityspecialityname,
                    obj: {...element},
                })
            })
            break    
        case 'clientprogram/masterdata/type/4':
            const cliententitysettingOptionList = dataList.cliententitysetting
                ? dataList.cliententitysetting
                : []
            cliententitysettingOptionList.forEach(element => {
                dropDownData.push({
                    value: element.cliententitysettingid,
                    label: element.cliententitysettingname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/18/1':
            const contactRoleOptionList1 = dataList.contactrole
                ? dataList.contactrole
                : []
            contactRoleOptionList1.forEach(element => {
                dropDownData.push({
                    value: element.contactroleid,
                    label: element.contactrolename,
                    obj: {...element},
                    // obj: {...element, label: element.practicesettingname},
                })
            })
            break
        case 'clientprogram/masterdata/type/18/0':
            const contactRoleOptionList0 = dataList.contactrole
                ? dataList.contactrole
                : []
            contactRoleOptionList0.forEach(element => {
                dropDownData.push({
                    value: element.contactroleid,
                    label: element.contactrolename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/18':
            const contactRoleOptionList = dataList.contactrole ? dataList.contactrole : []
            contactRoleOptionList.forEach(element => {
                dropDownData.push({
                    value: element.contactroleid,
                    label: element.contactrolename,
                    obj: {...element},
                    // obj: {...element, label: element.practicesettingname},
                })
            })
            break
        case 'clientprogram/masterdata/type/12':
            const optionList = dataList.areatype ? dataList.areatype : []
            optionList.forEach(element => {
                dropDownData.push({
                    value: element.areatypeid,
                    label: element.areatypename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/11':
            const optionListClinician = dataList.cliniciantype
                ? dataList.cliniciantype
                : []
            optionListClinician.forEach(element => {
                dropDownData.push({
                    value: element.cliniciantypeid,
                    label: element.cliniciantypename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/31':
            const optionListProfession = dataList.profession ? dataList.profession : []
            optionListProfession.forEach(element => {
                dropDownData.push({
                    value: element.professionid,
                    label: element.professionname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/32':
            const optionListCareforurologicpatients = dataList.careforurologicpatients
                ? dataList.careforurologicpatients
                : []
            optionListCareforurologicpatients.forEach(element => {
                dropDownData.push({
                    value: element.careforurologicpatientsid,
                    label: element.careforurologicpatientsname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/41':
            const optionListNoncliniciantype = dataList.noncliniciantype
                ? dataList.noncliniciantype
                : []
            optionListNoncliniciantype.forEach(element => {
                dropDownData.push({
                    value: element.noncliniciantypeid,
                    label: element.noncliniciantypename,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/program/role':
            dataList.forEach(element => {
                dropDownData.push({
                    value: element.contactroleid,
                    label: element.role,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/25':
            const contactTypeOptionList = dataList.contacttype ? dataList.contacttype : []
            contactTypeOptionList.forEach(element => {
                dropDownData.push({
                    value: element.contacttypeid,
                    label: element.contacttypename,
                    obj: {...element},
                })
            })
            break
        case 'agreement/contact/role/0':
            dataList.forEach(element => {
                dropDownData.push({
                    value: element.cliententitycontactid,
                    label: element.emailaddress,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/paymentuserdetails':
            dataList.users &&
                dataList.users.forEach(element => {
                    dropDownData.push({
                        value: element.emailaddress,
                        label: element.emailaddress,
                        obj: {...element},
                    })
                })
            break
        case 'agreement/contact/role/2':
            dataList.forEach(element => {
                dropDownData.push({
                    value: element.cliententitycontactid,
                    label: element.emailaddress,
                    obj: {...element},
                })
            })
            break
        case 'agreement/type':
            dataList.forEach(element => {
                dropDownData.push({
                    value: element.agreementid,
                    label: element.agreementname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/zipcode/':
            dataList.forEach(element => {
                dropDownData.push({
                    value: element.value,
                    label: element.description,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/masterdata/type/22':
            dataList.designation.forEach(element => {
                dropDownData.push({
                    value: element.designationid,
                    label: element.designationname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/1':
            dataList.gendertype.forEach(element => {
                dropDownData.push({
                    value: element.gendertypeid,
                    label: element.gendertypename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/33':
            dataList.title.forEach(element => {
                dropDownData.push({
                    value: element.titleid,
                    label: element.titlename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/speciality':
            const arr = getUniqueObjectArray(dataList.speciality, 'specialityid')
            // const arr = dataList.speciality
            arr.forEach(element => {
                dropDownData.push({
                    value: element.specialityid,
                    label: element.specialityname,
                    obj: {...element},
                })
            })
            break

        // Technical Survey
        case 'cliententity/contact':
            const ContactList =
                dataList.cliententitycontacts && dataList.cliententitycontacts
                    ? dataList.cliententitycontacts
                    : []
            ContactList.forEach(element => {
                dropDownData.push({
                    value: element.cliententitycontactid,
                    label: element.contactname,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/systeminformation/1':
            const EhrNameList = dataList && dataList ? dataList : []
            EhrNameList.forEach(element => {
                dropDownData.push({
                    value: element.ehrsystemid,
                    label: element.ehrsystemname,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/systeminformation/2':
            const LisNameList = dataList && dataList ? dataList : []
            LisNameList.forEach(element => {
                dropDownData.push({
                    value: element.lissystemid,
                    label: element.lissystemname,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/systeminformation/3':
            const PmNameList = dataList && dataList ? dataList : []
            PmNameList.forEach(element => {
                dropDownData.push({
                    value: element.pmsystemid,
                    label: element.pmsystemname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/systeminformation/4':
            const RcmNameList = dataList && dataList ? dataList : []
            RcmNameList.forEach(element => {
                dropDownData.push({
                    value: element.rcmsystemid,
                    label: element.rcmsystemname,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/masterdata/type/13':
            const ehrhostingList =
                dataList.ehrhost && dataList.ehrhost ? dataList.ehrhost : []
            ehrhostingList.forEach(element => {
                dropDownData.push({
                    value: element.ehrhostid,
                    label: element.ehrhostname,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/masterdata/type/21':
            const ehrstagingList =
                dataList.ehrstage && dataList.ehrstage ? dataList.ehrstage : []
            ehrstagingList.forEach(element => {
                dropDownData.push({
                    value: element.ehrstageid,
                    label: element.ehrstagename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/23':
            const entityList =
                dataList.entitytype && dataList.entitytype ? dataList.entitytype : []
            entityList.forEach(element => {
                dropDownData.push({
                    value: element.entitytypeid,
                    label: element.entitytypename,
                    obj: {...element},
                })
            })
            break

        case 'cliententity/tin':
            const TIN = dataList.cliententitytin ? dataList.cliententitytin : []
            TIN.forEach(element => {
                dropDownData.push({
                    value: element.cliententitytininformationid,
                    label: element.tin,
                    obj: {
                        cliententitytininformationid:
                            element.cliententitytininformationid,
                        tin: element.tin,
                    },
                })
            })
            break

        case 'clientprogram/masterdata/type/26':
            const ehrRdbmsList = dataList.rdbms && dataList.rdbms ? dataList.rdbms : []
            ehrRdbmsList.forEach(element => {
                dropDownData.push({
                    value: element.rdbmsid,
                    label: element.rdbmsname,
                    obj: {...element},
                })
            })
            break

        case 'clientprogram/masterdata/type/34':
            const ehrFileFormatList =
                dataList.ehrfileformat && dataList.ehrfileformat
                    ? dataList.ehrfileformat
                    : []
            ehrFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.ehrfileformatid,
                    label: element.ehrfileformatname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/35':
            const pmFileFormatList =
                dataList.pmfileformat && dataList.pmfileformat
                    ? dataList.pmfileformat
                    : []
            pmFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.pmfileformatid,
                    label: element.pmfileformatname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/54':
            const rcmFileFormatList =
                dataList.rcmfileformat && dataList.rcmfileformat
                    ? dataList.rcmfileformat
                    : []
            rcmFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.rcmfileformatid,
                    label: element.rcmfileformatname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/36':
            const lisFileFormatList =
                dataList.lisfileformat && dataList.lisfileformat
                    ? dataList.lisfileformat
                    : []
            lisFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.lisfileformatid,
                    label: element.lisfileformatname,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/42':
            const varTypeList =
                dataList.vartype && dataList.vartype ? dataList.vartype : []
            varTypeList.forEach(element => {
                dropDownData.push({
                    value: element.vartypeid,
                    label: element.vartypename,
                    obj: {...element},
                })
            })
            break

        //Technical Survey MyAccount
        case 'myaccount/cliententity/contact':
            const MyAccountContactList =
                dataList.cliententitycontacts && dataList.cliententitycontacts
                    ? dataList.cliententitycontacts
                    : []
            MyAccountContactList.forEach(element => {
                dropDownData.push({
                    value: element.cliententitycontactid,
                    label: element.contactname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/technicalsurvey/systeminformation/1':
            const MyAccountEhrNameList = dataList && dataList ? dataList : []
            MyAccountEhrNameList.forEach(element => {
                dropDownData.push({
                    value: element.ehrsystemid,
                    label: element.ehrsystemname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/technicalsurvey/systeminformation/2':
            const MyAccountLisNameList = dataList && dataList ? dataList : []
            MyAccountLisNameList.forEach(element => {
                dropDownData.push({
                    value: element.lissystemid,
                    label: element.lissystemname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/technicalsurvey/systeminformation/3':
            const MyAccountPmNameList = dataList && dataList ? dataList : []
            MyAccountPmNameList.forEach(element => {
                dropDownData.push({
                    value: element.pmsystemid,
                    label: element.pmsystemname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/technicalsurvey/systeminformation/4':
            const MyAccountRcmNameList = dataList && dataList ? dataList : []
            MyAccountRcmNameList.forEach(element => {
                dropDownData.push({
                    value: element.rcmsystemid,
                    label: element.rcmsystemname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/cliententity/masterdata/type/13':
            const MyAccountehrhostingList =
                dataList.ehrhost && dataList.ehrhost ? dataList.ehrhost : []
            MyAccountehrhostingList.forEach(element => {
                dropDownData.push({
                    value: element.ehrhostid,
                    label: element.ehrhostname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/cliententity/masterdata/type/21':
            const MyAccountehrstagingList =
                dataList.ehrstage && dataList.ehrstage ? dataList.ehrstage : []
            MyAccountehrstagingList.forEach(element => {
                dropDownData.push({
                    value: element.ehrstageid,
                    label: element.ehrstagename,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/cliententity/masterdata/type/26':
            const MyAccountehrRdbmsList =
                dataList.rdbms && dataList.rdbms ? dataList.rdbms : []
            MyAccountehrRdbmsList.forEach(element => {
                dropDownData.push({
                    value: element.rdbmsid,
                    label: element.rdbmsname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/cliententity/masterdata/type/34':
            const MyAccountehrFileFormatList =
                dataList.ehrfileformat && dataList.ehrfileformat
                    ? dataList.ehrfileformat
                    : []
            MyAccountehrFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.ehrfileformatid,
                    label: element.ehrfileformatname,
                    obj: {...element},
                })
            })
            break
        case 'myaccount/cliententity/masterdata/type/35':
            const MyAccountpmFileFormatList =
                dataList.pmfileformat && dataList.pmfileformat
                    ? dataList.pmfileformat
                    : []
            MyAccountpmFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.pmfileformatid,
                    label: element.pmfileformatname,
                    obj: {...element},
                })
            })
            break
        case 'myaccount/cliententity/masterdata/type/36':
            const MyAccountlisFileFormatList =
                dataList.lisfileformat && dataList.lisfileformat
                    ? dataList.lisfileformat
                    : []
            MyAccountlisFileFormatList.forEach(element => {
                dropDownData.push({
                    value: element.lisfileformatid,
                    label: element.lisfileformatname,
                    obj: {...element},
                })
            })
            break

        case 'myaccount/cliententity/tin':
            const myAccountTIN = dataList.cliententitytin ? dataList.cliententitytin : []
            myAccountTIN.forEach(element => {
                dropDownData.push({
                    value: element.cliententitytininformationid,
                    label: element.tin,
                    obj: {
                        cliententitytininformationid:
                            element.cliententitytininformationid,
                        tin: element.tin,
                    },
                })
            })
            break
        case 'user/program/cliententity':
            const cliententityList =
                dataList.cliententity && dataList.cliententity.length > 0
                    ? dataList.cliententity
                    : []
            cliententityList.forEach(element => {
                dropDownData.push({
                    value: element.cliententityid,
                    label: element.practiceid + ' - ' + element.name,
                    obj: {
                        cliententityid: element.cliententityid,
                        name: element.practiceid + ' - ' + element.name,
                    },
                })
            })
            break
        case 'user/program':
            const subscribedProgramList =
                dataList.programs && dataList.programs.length > 0 ? dataList.programs : []

            subscribedProgramList.forEach(element => {
                dropDownData.push({
                    value: element.clientprogramid,
                    label: element.name,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/roles':
            const roleList =
                dataList.roles && dataList.roles.length > 0 ? dataList.roles : []
            roleList.forEach(element => {
                dropDownData.push({
                    value: element.clientprogramrolemappingid,
                    label: element.name,
                    obj: {...element},
                })
            })
            break
        case 'myaccount/cliententity/masterdata/type/18':
            const myAccountContactRoleOptionList = dataList.contactrole
                ? dataList.contactrole
                : []
            myAccountContactRoleOptionList.forEach(element => {
                dropDownData.push({
                    value: element.contactroleid,
                    label: element.contactrolename,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/43':
            const optionListYesNotype = dataList.isaptamember ? dataList.isaptamember : []
            optionListYesNotype.forEach(element => {
                dropDownData.push({
                    value: element.isaptamemberid,
                    label: element.isaptamembername,
                    obj: {...element},
                })
            })
            break
        case 'clientprogram/masterdata/type/51':
            const memberpopulation = dataList.memberpopulation
                ? dataList.memberpopulation
                : []
            memberpopulation.forEach(element => {
                dropDownData.push({
                    value: element.memberpopulationid,
                    label: element.memberpopulationname,
                    obj: {...element},
                })
            })
            break
        default:
            break
    }
    return dropDownData
}

export const removeExcludedFields = (props, formData) => {
    const returnValue = {}
    const sectionExcludedFields =
        props.mastersectiondetails.length > 0
            ? props.mastersectiondetails[0].jsonschema.excludeFromPayload
            : []

    if (sectionExcludedFields.length > 0)
        for (let [key, value] of Object.entries(formData)) {
            if (sectionExcludedFields.indexOf(key) === -1) returnValue[key] = value
        }
    return Object.keys(returnValue).length === 0 ? formData : returnValue
}

export const excludeSectionFields = (jsonschema, formData) => {
    const returnValue = {}
    const sectionExcludedFields = jsonschema.excludeFromPayload
        ? jsonschema.excludeFromPayload
        : []
    if (sectionExcludedFields.length > 0)
        for (let [key, value] of Object.entries(formData)) {
            if (sectionExcludedFields.indexOf(key) === -1) returnValue[key] = value
        }
    return Object.keys(returnValue).length === 0 ? formData : returnValue
}

export const getUniqueObjectArray = (arr, comp) => {
    const unique = arr
        .map(e => e[comp])
        // store the keys of the unique objects
        .map((e, i, final) => final.indexOf(e) === i && i)
        // eliminate the dead keys & store unique objects
        .filter(e => arr[e])
        .map(e => arr[e])

    return unique
}

export const formateDate = (date, dateFormat) => {
    const _date = new Date(date)
    return fnDateFormat(
        fnFormatNumber(_date.getMonth() + 1),
        fnFormatNumber(_date.getDate()),
        fnFormatNumber(_date.getFullYear()),
        dateFormat
    ).join(dateFormat.replace(/[^-/:]/g, '').replace(/([-/:])+/g, '$1'))

    function fnFormatNumber(number) {
        if (/[0-9]+/.test(number)) {
            number = Number(number)
            return number < 10 ? ('0' + number).toString() : number.toString()
        }
        return number
    }

    function fnDateFormat(mm, dd, yy, dateFormat) {
        switch (dateFormat.toUpperCase().replace(/[^A-Z]/gi, '')) {
            case 'MMDDYYYY':
                return [mm, dd, yy]
            case 'DDMMYYYY':
                return [dd, mm, yy]
            case 'YYYYMMDD':
                return [yy, mm, dd]
            default:
                return [mm, dd, yy]
        }
    }
}

export function getSetCurrentDateTime(inputDate = '', separator = '/') {
    let newDate = inputDate ? new Date(inputDate) : new Date()
    let date = newDate.getDate()
    let month = newDate.getMonth() + 1
    let year = newDate.getFullYear()
    let time =
        newDate.getHours() + ':' + newDate.getMinutes() + ':' + newDate.getSeconds()

    return `${
        month < 10 ? `0${month}` : `${month}`
    }${separator}${date}${separator}${year} ${time}`
}

export const date_diff_indays = function(date1, date2) {
    if (date1 && date2) {
        let dt1 = new Date(date1)
        let dt2 = new Date(date2)
        return Math.floor(
            (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
                Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
                (1000 * 60 * 60 * 24)
        )
    } else return null
}

export const adjustHeaderProp = headerProp => {
    let newHeaderProp = headerProp

    if (headerProp.hasOwnProperty('client-entity-id')) {
        if (headerProp.hasOwnProperty('parent-client-entity-id')) {
            return newHeaderProp
        } else {
            let key2 = sessionStorage.getItem('sessionParentClientEntityId')
            if (key2) return {...headerProp, 'parent-client-entity-id': key2}
            return newHeaderProp
        }
    } else {
        let key = sessionStorage.getItem('sessionClientEntityId')
        if (key) {
            newHeaderProp['client-entity-id'] = key
        }
        let key3 = sessionStorage.getItem('sessionParentClientEntityId')
        if (key3) {
            newHeaderProp['parent-client-entity-id'] = key3
        }
        return newHeaderProp
    }
}

export const YearPicker = props => {
    return (
        <DatePicker
            label={props.label}
            value={props.value}
            onChange={props.handleDateChange}
            views={['year']}
        />
    )
}

// const ajdustSameParentClient = (header) => {
//     if (header.hasOwnProperty('client-entity-id') && header.hasOwnProperty('parent-client-entity-id')){
//         if(header['client-entity-id']===header['parent-client-entity-id']){
//             delete header['client-entity-id']
//         }
//     }
//     return header
// }
